import * as React from "react";
import { AccountPresenterKind } from "../model/presenter/types";
import { RuleChangeLog, RuleHistory } from "../model/spread/types";
import AccountTotal from "./AccountTotal";
import ChildAccountsSection from "./ChildAccountsSection";

interface CalculatedAccountSectionProps {
  account: AccountPresenterKind<"CALCULATED">;
  hierarchyLevel: number;
  ruleHistory: RuleHistory;
  initialChangelog: RuleChangeLog;
  periods: string[];
}

export interface CalculatedAccountSectionState {
  expanded: boolean;
}

export default class CalculatedAccountSection extends React.Component<
  CalculatedAccountSectionProps,
  CalculatedAccountSectionState
> {
  constructor(props: CalculatedAccountSectionProps) {
    super(props);
    this.state = { expanded: true };
  }

  public handleExpand = (event: React.MouseEvent<HTMLDivElement>) => {
    this.setState({
      expanded: !this.state.expanded
    });
  };

  public render(): JSX.Element {
    const {
      account,
      hierarchyLevel,
      ruleHistory,
      initialChangelog
    } = this.props;
    const { expanded } = this.state;
    return (
      <div className="CalculatedAccountSection">
        <AccountTotal
          account={account}
          key={account.id}
          hierarchyLevel={hierarchyLevel}
          handleExpand={this.handleExpand}
          expanded={expanded}
        />
        {expanded ? (
          <ChildAccountsSection
            childAccounts={account.children}
            hierarchyLevel={hierarchyLevel + 1}
            ruleHistory={ruleHistory}
            initialChangelog={initialChangelog}
            periods={this.props.periods}
          />
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/CalculatedAccountSection.tsx